import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const WHATSAPP_NUMBER = '5567998238156';
  const defaultMessage = encodeURIComponent("Olá! Gostaria de mais informações sobre os móveis.");

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="contact-info">
          <h3>Soluções</h3>
          <p>Endereço: Rua Raposo Tavares, 315, Sala 12 - Jardim Paulista - Campo Grande/MS - 79050-050</p>
          <p>Telefone: (67) 99823-8156</p>
          <p>Email: atendimento@solucoesmobiliarios.com.br</p>
        </div>

        <div className="social-links">
          <h3>Siga-nos</h3>
          
          <div className="social-icons">
            <a href="https://www.instagram.com/solucoesemmobiliario?igsh=MWJlYnE2cXMwMGM1NQ==" target="_blank" rel="noopener noreferrer" title="Instagram">
              <i className="fab fa-instagram"></i>
            </a>

            {/* <a href="https://facebook.com/sua_loja" target="_blank" rel="noopener noreferrer" title="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a> */}

            <a 
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${defaultMessage}`} 
              target="_blank" 
              rel="noopener noreferrer" 
              title="WhatsApp"
            >
              <i className="fab fa-whatsapp"></i>
            </a>

            {/* <a href="https://linkedin.com/company/sua_loja" target="_blank" rel="noopener noreferrer" title="LinkedIn">
              <i className="fab fa-linkedin-in"></i>
            </a> */}
          </div>
        </div>

        <div className="legal-links">
          <h3>Informações</h3>
          <Link to="/politica-privacidade">Política de Privacidade</Link>
          <Link to="/termos-de-uso">Termos de Uso</Link>
        </div>
      </div>

      <div className="copyright">
        &copy; {currentYear} Soluções. Todos os direitos reservados.
      </div>
    </footer>
  );
};

export default Footer;